import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BehaviorSubject, Observable } from 'rxjs';

import {
  AuditDetection,
  Detection,
  DetectionResponse,
} from '../../people/models/detection.interface';
import { UploadedImage } from '../../../models/uploaded-image';
import { map } from 'rxjs/operators';
import { HttpService } from '../../../services/http.service';
import { DetectionThreshold } from '../models/detection-threshold';
import { ConfigService } from 'src/app/services/config.service';

@Injectable({ providedIn: 'root' })
export class DetectionService extends HttpService {
  endpoint: string;
  people = new BehaviorSubject([]);
  private selectedDetectionSubject = new BehaviorSubject<Detection>(null);
  private selectedDetectionImageSubject = new BehaviorSubject<Blob>(null);

  constructor(private http: HttpClient, private configService: ConfigService) {
    super();
    this.endpoint = this.configService.apiUrlV2 + '/detection';
  }

  public create(reason: string): Observable<AuditDetection> {
    const url = `${this.configService.apiUrl}/detections`;
    return this.http.post<AuditDetection>(url, { reason });
  }

  public get selectedDetectionImage$(): Observable<Blob> {
    return this.selectedDetectionImageSubject.asObservable();
  }

  public get selectedDetection$(): Observable<Detection> {
    return this.selectedDetectionSubject.asObservable();
  }

  public detect(picture: Blob): Observable<DetectionResponse> {
    const form = new FormData();
    form.set('photo', picture);
    return this.http.post<DetectionResponse>(this.endpoint, form);
  }

  public setSelectedDetection(detection: Detection) {
    this.selectedDetectionSubject.next(detection);
  }

  public setSelectedDetectionImage(image: UploadedImage) {
    this.selectedDetectionImageSubject.next(image.file);
  }

  public addPhoto(detection: any, image: UploadedImage): Observable<any> {
    const url = `${this.configService.apiUrl}/detections/${detection.id}/photos`;
    const data = new FormData();
    data.set('photo', image.file);
    return this.http.post(url, data);
  }

  public getPDF(detection: AuditDetection): Observable<Blob> {
    const url = `${this.configService.apiUrl}/detections/${detection.id}/pdf`;
    return this.http
      .get<Blob>(url, { responseType: 'blob' as any })
      .pipe(map(data => new Blob([data], { type: 'application/pdf' })));
  }

  public getDetectionThresholds(): Observable<DetectionThreshold[]> {
    const url = `${this.configService.apiUrl}/DetectionThresholds`;
    const request = this.http.get<DetectionThreshold[]>(url);
    return this.cacheFirst<DetectionThreshold[]>(url, request);
  }
}
